import React from "react";
import { TextField, Autocomplete } from "@mui/material";

const options = ["pending", "rejected", "accepted"];

const SelectStatus = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Status"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectStatus;
